
/* injects from baggage-loader */

import get from 'lodash/get'
import isEqual from 'lodash/isEqual'
import uniq from 'lodash/uniq'
import replaceAt from 'utils/replaceAt'
import loadTypes from 'utils/loadTypes'

import {chartDataReducer} from 'redux/modules/reports'

export const ANALYTICS_DATA = loadTypes('ANALYTICS_DATA')
export const ANALYTICS_DATA_TOTAL = loadTypes('ANALYTICS_DATA_TOTAL')
export const ANALYTICS_CHART_DATA = loadTypes('ANALYTICS_CHART_DATA')
export const ANALYTICS_DIMENSIONS = loadTypes('ANALYTICS_DIMENSIONS')
export const ANALYTICS_CLEAR_METRICS = 'ANALYTICS_CLEAR_METRICS'
export const ANALYTICS_REMOVE_PLOTTED_METRIC = 'ANALYTICS_REMOVE_PLOTTED_METRIC'
export const ANALYTICS_ADD_CHART = 'ANALYTICS_ADD_CHART'

const initialState = {
  data: null,
  total: null,
  availableDimensions: null,
  dimensions: null,
  loading: false,
  crossDimensions: ['merchantSite', 'channelGroup'],
  metrics: [
    'order:count-rf-touchpoint', 
    'order:count-rf-touched',
    'order:regCount-non-direct-touch',
    'order:regImpact-non-direct-touch'
  ],
  filters: {},
  charts: []
}

export default function analytics(state = initialState, action) {
  switch (action.type) {
    case ANALYTICS_DATA.REQUEST:
      const {queryParams} = action.request

      return {
        ...state,
        dimensions: queryParams.dimensions,
        loading: true,
        metrics: queryParams.metrics,
        filters: queryParams.filter || {},
        data: null
      }
    case ANALYTICS_DATA.SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.response,
        availableDimensions: state.availableDimensions || processAvailableDimensions(action.response, state.dimensions)
      }
    case ANALYTICS_DATA.FAILURE:
      return {
        ...state,
        loading: false
      }
    case ANALYTICS_DIMENSIONS.SUCCESS:
      return {
        ...state,
        loading: false,
        availableDimensions: processAvailableDimensions(action.response, state.dimensions)
      }
    case ANALYTICS_DATA_TOTAL.REQUEST:
      return {
        ...state,
        loading: true,
        total: null
      }
    case ANALYTICS_DATA_TOTAL.SUCCESS:
      return {
        ...state,
        loading: false,
        total: action.response[0]
      }
    case ANALYTICS_CLEAR_METRICS:
      return {
        ...state,
        metrics: []
      }
    case ANALYTICS_CHART_DATA.SUCCESS:
      return {
        ...state,
        loading: false,
        charts: analyticsGraphDataReducer(state.charts, action.params, action.response)
      }

    case ANALYTICS_ADD_CHART:
      return {
        ...state,
        charts: chartsReducer(state.charts, action.metric, action.dimension)
      }

    case ANALYTICS_REMOVE_PLOTTED_METRIC:
      return {
        ...state,
        charts: removeChartMetric(state.charts, action.metric, action.dimension)
      }

    default:
      return state
  }
}

function processAvailableDimensions(data, dimensions) {
  return dimensions.reduce((acc, dimension) => {
    acc[dimension] = uniq(data.map(item => get(item, `dimensions.${dimension}`)))
    return acc
  }, {})
}

function analyticsGraphDataReducer(charts, {metric, dimension}, data) {
  const chartIndex = charts.findIndex(chart => chart.metric === metric)
  const dimensionIndex = get(charts, [chartIndex, 'dimensions'], [])
    .findIndex(chartDimension => isEqual(chartDimension, dimension))
  const chart = get(charts, [chartIndex], {})
  const resultChart = {
    ...chart,
    data: chartDataReducer(chart.data, data, dimensionIndex, chart.metric)
  }

  return replaceAt(charts, chartIndex, resultChart)
}

function chartsReducer(charts, metric, dimension) {
  const chartIndex = charts.findIndex(chart => chart.metric === metric)
  const chart = charts[chartIndex] || {}
  const dimensions = chart.dimensions || []
  const resultChart = {
    ...chart,
    metric,
    dimensions: dimensions.some(dim => isEqual(dim, dimension)) ? dimensions : [...dimensions, dimension]
  }
  return replaceAt(charts, chartIndex, resultChart)
}

function removeChartMetric(charts, metric, dimension) {
  const chartIndex = charts.findIndex(chart => chart.metric === metric)
  if (chartIndex !== -1) {
    if (dimension) {
      const chart = charts[chartIndex]
      const chartDimensions = chart.dimensions
      const dimensionIndex = chartDimensions.findIndex(chartDimension => isEqual(chartDimension, dimension))
      if (dimensionIndex !== -1) {
        if (chartDimensions.length > 1) {
          return replaceAt(charts, chartIndex, {
            ...chart,
            dimensions: replaceAt(chartDimensions, dimensionIndex),
            data: Object.keys(chart.data).reduce((acc, date) => {
              acc[date] = replaceAt(chart.data[date], dimensionIndex)
              return acc
            }, {})
          })
        }
      } else {
        return charts
      }
    }
    return replaceAt(charts, chartIndex)
  } else {
    return charts
  }
}



// WEBPACK FOOTER //
// ./client/redux/modules/analytics/index.js